export const FREELANCER_CONTROL = () => "/freelancer-control";
